var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonAlas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18L25.9904 0H0.00961876L13 18Z",
    fill: "#d15371"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonAlas);
export default __webpack_public_path__ + "static/media/polygon-alas.ad2650840e941a5029e5c74d698cd5aa.svg";
export { ForwardRef as ReactComponent };